import { call, put, takeLatest } from 'redux-saga/effects';
import { myautoiqSegmentSettingsActions } from 'app/pages/MyautoiqSegmentSettingsComponent/slice';
import {
  fetchMyautoiqSegmentSettings,
  createMyautoiqSegmentSettings,
  updateMyautoiqSegmentSettings,
} from './data/myautoiqSegmentSettingsDataService';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

function* fetchMyautoiqSegmentSettingsSaga(action: ReturnType<any>) {
  try {
    const response = yield call(fetchMyautoiqSegmentSettings, {
      manufacturerId: action.payload.manufacturerId,
      makeId: action.payload.makeId,
    });
    yield put(
      myautoiqSegmentSettingsActions.requestMyautoiqSegmentSettingsSuccess(response),
    );
  } catch (error: any) {
    const message = error?.message || 'Myautoiq segment settings fetch failed';
    yield put(
      myautoiqSegmentSettingsActions.requestMyautoiqSegmentSettingsError(message),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message,
      }),
    );
  }
}

function* createMyautoiqSegmentSettingsSaga(action: ReturnType<any>) {
  try {
    yield call(createMyautoiqSegmentSettings, {
      manufacturerId: action.payload.manufacturerId,
      makeId: action.payload.makeId,
      data: action.payload.data,
    });
    yield put(
      myautoiqSegmentSettingsActions.requestCreateMyautoiqSegmentSettingsSuccess(),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Myautoiq segment settings created successfully',
      }),
    );
    yield put(
      myautoiqSegmentSettingsActions.requestMyautoiqSegmentSettings({
        manufacturerId: action.payload.manufacturerId,
        makeId: action.payload.makeId,
      }),
    );
  } catch (error: any) {
    const message = error?.message || 'Myautoiq segment settings create failed';
    yield put(
      myautoiqSegmentSettingsActions.requestCreateMyautoiqSegmentSettingsError(
        message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message,
      }),
    );
  }
}

function* updateMyautoiqSegmentSettingsSaga(action: ReturnType<any>) {
  try {
    yield call(updateMyautoiqSegmentSettings, {
      manufacturerId: action.payload.manufacturerId,
      makeId: action.payload.makeId,
      settingsId: action.payload.settingsId,
      data: action.payload.data,
    });
    yield put(
      myautoiqSegmentSettingsActions.requestUpdateMyautoiqSegmentSettingsSuccess(),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Myautoiq segment settings updated successfully',
      }),
    );
    yield put(
      myautoiqSegmentSettingsActions.requestMyautoiqSegmentSettings({
        manufacturerId: action.payload.manufacturerId,
        makeId: action.payload.makeId,
      }),
    );
  } catch (error: any) {
    const message = error?.message || 'Myautoiq segment settings update failed';
    yield put(
      myautoiqSegmentSettingsActions.requestUpdateMyautoiqSegmentSettingsError(
        message,
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message,
      }),
    );
  }
}

export function* watchMyautoiqSegmentSettingsSaga() {
  yield takeLatest(
    myautoiqSegmentSettingsActions.requestMyautoiqSegmentSettings.type,
    fetchMyautoiqSegmentSettingsSaga,
  );
  yield takeLatest(
    myautoiqSegmentSettingsActions.requestCreateMyautoiqSegmentSettings.type,
    createMyautoiqSegmentSettingsSaga,
  );
  yield takeLatest(
    myautoiqSegmentSettingsActions.requestUpdateMyautoiqSegmentSettings.type,
    updateMyautoiqSegmentSettingsSaga,
  );
}
